/**
 * Batch review progress bar — React port of partials/review/review_stats.html
 * (the iio-review-stats directive). Two stacked bars: reviewed (default color) and
 * not-reviewed (grey), widths proportional to their counts. Renders nothing until the
 * counts are known or when the batch is empty.
 */
export function BatchProgressBar({ reviewed, notReviewed }: { reviewed: number; notReviewed: number }) {
  const total = reviewed + notReviewed;
  if (total <= 0) return null;

  const reviewedPct = (reviewed / total) * 100;
  const notReviewedPct = (notReviewed / total) * 100;

  return (
    <div className="progress">
      <div className="progress-bar progress-bar-default" style={{ width: `${reviewedPct}%` }}>
        {reviewed.toLocaleString()} Reviewed
      </div>
      <div className="progress-bar" style={{ width: `${notReviewedPct}%`, backgroundColor: '#e6e6e6', color: '#808080' }}>
        {notReviewed.toLocaleString()} Not Reviewed
      </div>
    </div>
  );
}
